import * as React from "react";
import { useState, useEffect } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
import { Icon, Spinner } from "components/common";
const StyledInput = styled.div`
  width: 100%;

  & .form-group {
    margin-bottom: 0 !important;
  }

  & .input-group * {
    background: none !important;
  }

  & .input-group input {
    padding: 6px 0 !important;

    &:focus {
      box-shadow: none !important;
    }
  }

  & * {
    border: none;
  }
`;
function SearchRule({ query, searching, onSearch }) {
  const { t } = useTranslation("enterprise_security_sigma");
  const [localQuery, setLocalQuery] = useState(query);
  const [debouncedSearch, setDebouncedSeach] = useState(null);
  useEffect(() => setLocalQuery(query), [query]);
  const handleOnChange = (event) => {
    const { value } = event.target;
    setLocalQuery(value);
    if (debouncedSearch) clearTimeout(debouncedSearch);
    setDebouncedSeach(setTimeout(() => onSearch(value), 800));
  };
  return /* @__PURE__ */ React.createElement(StyledInput, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "search-rule",
      "data-testid": "search-rule",
      type: "text",
      name: "search-rule",
      value: localQuery,
      onChange: handleOnChange,
      placeholder: t("search_rule.placeholder"),
      addonAfter: searching ? /* @__PURE__ */ React.createElement(Spinner, { text: "" }) : /* @__PURE__ */ React.createElement(Icon, { name: "search" })
    }
  ));
}
export default SearchRule;
